import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import Login from '@/components/Login'
import Good from '@/components/Goods'
import Restaurant from '@/components/Restaurant'
import DinersNum from '@/components/DinersNum'
import Seller from '@/components/Seller'
import CartList from '@/components/CartList'
import Search from '@/components/Search'
import OrderList from '@/components/OrderList'
import BuffetSelect from '@/components/BuffetSelect'
import Buffet from '@/components/Buffet'
import BuffetMain from '@/components/BuffetMain'
import BuffetPay from '@/components/BuffetPay'
import Error from '@/components/Error'
import BuffetSetShow from '@/components/BuffetSetShow'
import GoodsMain from '@/components/GoodsMain'
import GoodsMainShow from '@/components/GoodsMainShow'
import BuffetSelectShow from '@/components/BuffetSelectShow'
import Unavailable from '@/components/Unavailable'
import Takeaway from '@/components/Takeaway'
import Result from '@/components/Result'
import LoginShow from '@/components/LoginShow'
import TakwawayCartList from '@/components/TakwawayCartList'
import TakwawayInfo from '@/components/TakwawayInfo'
import TakwawayCustomer from '@/components/TakwawayCustomer'
import TakeawayOrderList from '@/components/TakeawayOrderList'
Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [

        {
            path: '/',
            name: 'Login',
            component: Login,
            meta: { keepAlive: true }
        },
        {
            path: '/loginShow',
            name: 'LoginShow',
            component: LoginShow,
            meta: { keepAlive: true }
        },
        {
            path: '/index',
            name: 'Index',
            component: Index,
            meta: { keepAlive: true }
        },
        {
            path: '/good',
            name: 'Good',
            component: Good,
            meta: { keepAlive: true }
        }
        ,
        {
            path: '/restaurant',
            name: 'Restaurant',
            component: Restaurant,
            meta: { keepAlive: true }
        },
        {
            path: '/dinersNum',
            name: 'DinersNum',
            component: DinersNum,
            meta: { keepAlive: true }
        },
        
        {
            path: '/seller',
            name: 'Seller',
            component: Seller,
            meta: { keepAlive: true }
        },
        {
            path: '/cartList',
            name: 'CartList',
            component: CartList,
            meta: { keepAlive: false }
        }
        ,
        {
            path: '/orderList',
            name: 'OrderList',
            component: OrderList,
            meta: { keepAlive: false }
        }
        ,
        {
            path: '/search',
            name: 'Search',
            component: Search,
            meta: { keepAlive: true }
        }
        ,
        {
            path: '/buffetSelect',
            name: 'BuffetSelect',
            component: BuffetSelect,
            meta: { keepAlive: false }

        },
        {
            path: '/unavailable',
            name: 'Unavailable',
            component: Unavailable,
            meta: { keepAlive: false }
        },
        {
            path: '/buffet',
            name: 'Buffet',
            component: Buffet,
            meta: { keepAlive: true }
        },
        {
            path: '/buffetMain',
            name: 'BuffetMain',
            component: BuffetMain,
            meta: { keepAlive: true }
        },
        {
            path: '/goodsMain',
            name: 'GoodsMain',
            component: GoodsMain,
            meta: { keepAlive: true }
        },
        {
            path: '/buffetSetShow',
            name: 'BuffetSetShow',
            component: BuffetSetShow,
            meta: { keepAlive: true }
        },
        {
            path: '/goodsMainShow',
            name: 'GoodsMainShow',
            component: GoodsMainShow,
            meta: { keepAlive: true }
        },
        {
            path: '/buffetSelectShow',
            name: 'BuffetSelectShow',
            component: BuffetSelectShow,
            meta: { keepAlive: true }
        },
        {
            path: '/buffetPay',
            name: 'BuffetPay',
            component: BuffetPay,
            meta: { keepAlive: true }
        },
        {
            path: '/takeaway',
            name: 'Takeaway',
            component: Takeaway,
            meta: { keepAlive: true }
        },
        {
            path: '/takwawayCartList',
            name: 'TakwawayCartList',
            component: TakwawayCartList,
            meta: { keepAlive: true }
        },
        {
            path: '/takwawayInfo',
            name: 'TakwawayInfo',
            component: TakwawayInfo,
            meta: { keepAlive: true }
        },
        {
            path: '/takwawayCustomer',
            name: 'TakwawayCustomer',
            component: TakwawayCustomer,
            meta: { keepAlive: true }
        },
        {
            path: '/takeawayOrderList',
            name: 'TakeawayOrderList',
            component: TakeawayOrderList,
            meta: { keepAlive: true }
        },
        {
            path: '/error',
            name: 'Error',
            component: Error,
            meta: { keepAlive: true }
        },
        {
            path: '*', redirect: '/404', hidden: true
        },
        {
            path: '/404',
            name: 'NotFound',
            component: Error,
            meta: { keepAlive: true }
        },
        {
            path: '/result',
            name: 'Result',
            component: Result,
            meta: { keepAlive: true }
        }
     
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js